import React from 'react';

import { InsightCardFactoryProps, InsightCardProps, InsightCardType } from '../types';

import InlineHeadlineMarqueeCard from './InlineHeadlineMarqueeCard';
import StackedHeadlineMarqueeCard from './StackedHeadlineMarqueeCard';
import AdsRanMarqueeCard from './AdsRanMarqueeCard';
import InlineHeadlineMarqueeCardWithSnackbar from './InlineHeadlineMarqueeCardWithSnackbar';
import CopyCtaLeftImageRight from './CopyCtaLeftImageRight';
import ElevatePhotosCard from './ElevatePhotosCard';
import ShareInstagramCard from './ShareInstagramCard';
import AddSpecialtiesCard from './AddSpecialtiesCard';
import PositiveReviewAssetCard from './PositiveReviewAssetCard';
import InlineHeadlineWithCopyCtaCard from './InlineHeadlineWithCopyCtaCard';

export const CARD_TYPES: Record<string, InsightCardType> = {
  stackedHeadline: 'stackedHeadline',
  inlineHeadline: 'inlineHeadline',
  adsRan: 'adsRan',
  inlineHeadlineWithSnackbar: 'inlineHeadlineWithSnackbar',
  copyCtaLeftImageRight: 'copyCtaLeftImageRight',
  elevatePhotos: 'elevatePhotos',
  shareInstagram: 'shareInstagram',
  addSpecialties: 'addSpecialties',
  positiveReviewAsset: 'positiveReviewAsset',
  inlineHeadlineWithCopyCta: 'inlineHeadlineWithCopyCta',
};

const componentMap: Record<string, React.FC<InsightCardProps>> = {
  [CARD_TYPES.stackedHeadline]: StackedHeadlineMarqueeCard,
  [CARD_TYPES.inlineHeadline]: InlineHeadlineMarqueeCard,
  [CARD_TYPES.inlineHeadlineWithSnackbar]: InlineHeadlineMarqueeCardWithSnackbar,
  [CARD_TYPES.adsRan]: AdsRanMarqueeCard,
  [CARD_TYPES.elevatePhotos]: ElevatePhotosCard,
  [CARD_TYPES.copyCtaLeftImageRight]: CopyCtaLeftImageRight,
  [CARD_TYPES.shareInstagram]: ShareInstagramCard,
  [CARD_TYPES.addSpecialties]: AddSpecialtiesCard,
  [CARD_TYPES.positiveReviewAsset]: PositiveReviewAssetCard,
  [CARD_TYPES.inlineHeadlineWithCopyCta]: InlineHeadlineWithCopyCtaCard,
};

const InsightCardFactory: React.FC<InsightCardFactoryProps> = ({
  type = CARD_TYPES.inlineHeadline,
  cardProps,
}) => {
  const ChildComponent = componentMap[type];
  return (
    <React.Fragment>
      {ChildComponent && <ChildComponent {...cardProps} />}
    </React.Fragment>
  );
};

export default InsightCardFactory;
